import httpClient from "./httpClient";

const base = "/student-attendance-marksheet";

export function computeAttendanceTotals(payload) {
  return httpClient.post(`${base}/compute`, payload).then((res) => res.data.data);
}

export function saveAttendanceForMarksheet(payload) {
  return httpClient.post(`${base}/save`, payload).then((res) => res.data);
}

export function listAttendanceMarksheetGroups() {
  return httpClient.get(`${base}/groups`).then((res) => res.data.data);
}

export function deleteAttendanceForMarksheet(classConfigId, examId, periodId) {
  return httpClient.delete(base, { params: { classConfigId, examId, periodId } }).then((res) => res.data);
}
